import { FC, ReactNode } from "react";
import styled from "styled-components";

interface Props {
  title: string;
  actions?: ReactNode;
  subtitle?: ReactNode;
}

const Page: FC<Props> = ({ children, actions, title, subtitle }) => {
  return (
    <Content>
      <Header>
        <Side>
          <Title>{title}</Title>
          {subtitle}
        </Side>
        <Side>{actions}</Side>
      </Header>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Content>
  );
};

const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 8px 0;
`;
const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
`;

const Side = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const Title = styled.h1`
  font-size: 1.5rem;
  line-height: 2.5rem;
  font-weight: 500;
  color: var(--color-gray-700);
`;
const ChildrenWrapper = styled.div`
  padding-bottom: 8px;
`;
export default Page;
